import { ApolloLink, HttpLink } from '@apollo/client';

import { createErrorLink } from './apolloErrorLink';
import getEnv from './utils/getEnv';

export function getBackendApolloLinks(): ApolloLink {
  const { REACT_APP_GRAPHQL_URL } = getEnv();

  const underwritingEndpoint = new HttpLink({ uri: REACT_APP_GRAPHQL_URL });

  return ApolloLink.from([createErrorLink(), underwritingEndpoint]);
}
